export const useDocStorePermission = (docStorePermissions: string[] = []) => {
    return (permission: string): boolean => docStorePermissions.includes(permission);
  };
  